module.exports = __webpack_public_path__ + "img/bdtLogo.f2c2ffef.png";